import { useEffect, useState } from "react";
import { apiClient } from "@/lib/apiClient";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { Users, UserCheck, UserX, AlertTriangle, Percent } from "lucide-react";

interface Painel {
  dataReferencia: string;
  justificativasPendentes: number;
  funcionariosAtivos: number;
  bateramNoDia: number;
  ausentesNoDia: number;
  percentualAssiduidade: number;
}

function Metrica({ titulo, valor, sub, icon: Icon, cor }: { titulo: string; valor: string | number; sub?: string; icon: any; cor: string }) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">{titulo}</CardTitle>
        <Icon className={`h-5 w-5 ${cor}`} />
      </CardHeader>
      <CardContent>
        <div className="text-3xl font-bold">{valor}</div>
        {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
      </CardContent>
    </Card>
  );
}

export default function PainelPage() {
  const [p, setP] = useState<Painel | null>(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    apiClient.get<Painel>("/api/rh/ponto/painel")
      .then((r) => setP(r.data))
      .catch((e) => toast.error(e.message ?? "Falha ao carregar o painel."))
      .finally(() => setCarregando(false));
  }, []);

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Painel de Ponto</h1>
        <p className="text-sm text-muted-foreground">
          Referência: {p ? new Date(p.dataReferencia).toLocaleDateString("pt-BR") : "hoje"}
        </p>
      </div>

      {carregando ? (
        <p className="text-muted-foreground">Carregando…</p>
      ) : !p ? (
        <p className="text-muted-foreground">Sem dados.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Metrica titulo="Assiduidade do dia" valor={`${p.percentualAssiduidade}%`} sub={`${p.bateramNoDia} de ${p.funcionariosAtivos} bateram`} icon={Percent} cor="text-primary" />
          <Metrica titulo="Funcionários ativos" valor={p.funcionariosAtivos} icon={Users} cor="text-blue-500" />
          <Metrica titulo="Bateram hoje" valor={p.bateramNoDia} icon={UserCheck} cor="text-green-600" />
          <Metrica titulo="Ausentes hoje" valor={p.ausentesNoDia} icon={UserX} cor="text-orange-500" />
          <Metrica titulo="Justificativas pendentes" valor={p.justificativasPendentes} sub="aguardando aprovação" icon={AlertTriangle} cor="text-amber-500" />
        </div>
      )}
    </div>
  );
}
